import { GenericService } from './generic.service';
import { Patient } from '@/models';

export class OrganisationPatientService extends GenericService<Patient> {

  constructor(organisationId: string) {
    super(`v1/organisations/${organisationId}/patients`);
  }
}
